import * as util from '#packages/util';

import * as tpaAddRemoveDSService from './tpaAddRemoveDSService';
import experiment from 'experiment';

import type { EditorAPI } from '#packages/editorAPI';
import type { CompRef, AppData, CompData } from 'types/documentServices';

interface DeleteSectionOptions {
  shouldShowEditorRemovePanel?: boolean;
}

const deleteWidget = function (
  editorAPI: EditorAPI,
  compRef: CompRef,
  showMessage?: boolean,
  _originalRemoveFunction: () => void = () => {},
  isCopyPaste?: boolean,
) {
  const compData = editorAPI.components.data.get(compRef);
  const isPremium = experiment.isOpen('se_appDefIdUpdates')
    ? editorAPI.dsRead.tpaV2.app.isPremium(compData.appDefinitionId)
    : editorAPI.dsRead.tpa.app.isPremium(compData.applicationId);
  const appData = experiment.isOpen('se_appDefIdUpdates')
    ? editorAPI.dsRead.tpa.app.getDataByAppDefId(compData.appDefinitionId)
    : editorAPI.dsRead.tpa.app.getData(compData.applicationId);
  const hasSection = editorAPI.dsRead.tpa.app.hasSections(appData);

  return new Promise<void>((resolve) => {
    if (isPremium && !hasSection && showMessage) {
      editorAPI.panelManager.openPanel(
        'tpaPanels.confirmation.premiumTPADelete',
        {
          appName: appData.appDefinitionName,
          appDefId: appData.appDefinitionId,
          onConfirm() {
            onDeleteWidgetConfirm(editorAPI, compData, compRef, appData);
            resolve();
          },
        },
        true,
      );
    } else if (
      editorAPI.dsRead.tpaV2.app.isLastAppComp(appData.appDefinitionId) &&
      !isCopyPaste
    ) {
      editorAPI.platform.applications.uninstall(appData, true, {
        onSuccess: () => {
          resolve();
        },
        compRef,
      });
    } else {
      tpaAddRemoveDSService.deleteWidget(editorAPI, compRef);
      resolve();
    }
  });
};

const onDeleteWidgetConfirm = function (
  editorAPI: EditorAPI,
  compData: CompData,
  compRef: CompRef,
  appData: AppData,
) {
  const isLastComp = experiment.isOpen('se_appDefIdUpdates')
    ? editorAPI.dsRead.tpaV2.app.isLastAppComp(compData.appDefId)
    : editorAPI.dsRead.tpa.app.isLastAppComp(compData.applicationId);
  tpaAddRemoveDSService.deleteWidget(editorAPI, compRef);

  const params = {
    app_id: appData.appDefinitionId,
    app_site_id: appData.instanceId,
    instance_id: compRef.id,
    is_last_tpa: isLastComp ? 1 : 0,
    component_type: 'tpa',
  };

  editorAPI.bi.event(util.bi.events.REMOVE_COMPONENT_SECOND_STEP_CLICK, params);
};

const deleteSection = async function (
  editorAPI: EditorAPI,
  pageId: string,
  pageName: string,
  appData: AppData,
  showMessage?: boolean,
  completeCallback?: () => void,
  tpasOnPageBiParams?: Object,
  options?: DeleteSectionOptions,
) {
  const shouldShowEditorRemovePanel =
    options?.shouldShowEditorRemovePanel ?? true;
  return editorAPI.platform.applications.uninstall(
    appData,
    shouldShowEditorRemovePanel,
    {
      onSuccess: completeCallback,
      origin: 'deleteSection',
      compRef: editorAPI.components.get.byId(pageId),
    },
  );
};

export { deleteWidget, deleteSection };
